<template>
  <div class="bias-fx2-coupon relative overflow-hidden">
    <Banner :with-bias-banner="true" />
    <div class="page-bg absolute h-full left-50 top-0 transform-translate-50 pointer-events-none" />
    <section class="hero relative text-center flex justify-center items-center flex-col overflow-hidden">
      <h2 class="z-10 tracking-normal m-0">
        2020 POSITIVE GRID
      </h2>
      <div class="h1-wrap">
        <h1 class="z-10 tracking-normal m-0 font-semibold relative inline-block">
          过年红包鼠不完
        </h1>
      </div>
      <h3 class="z-10 tracking-normal m-0">
        BIAS FX 2 及扩展包限量超杀优惠
      </h3>
      <div class="background-img z-0 absolute left-50 top-50 transform-translate-50" />
    </section>
    <div class="divider relative overflow-hidden w-full h-10">
      <img
        class="transform-translate-50 left-50 top-50 absolute"
        src="@/assets/bias-fx2-coupon/group-7-down.svg"
      >
    </div>
    <section class="time">
      <h4 class="text-lg">
        活动时间
      </h4>
      <div>
        <h2 class="text-4xl inline-block my-0">
          2020.
          <span class="text-sm block">&nbsp;</span>
        </h2>
        <h2 class="text-4xl inline-block my-0">
          1.20 -
          <span class="text-sm text-left block">10:00</span>
        </h2>
        <h2 class="text-4xl inline-block my-0">
          1.23
          <span class="text-sm text-left block">23:59</span>
        </h2>
      </div>
      <h2 class="text-4xl">
        每日上午 10 点正式开抢
      </h2>
    </section>
    <section class="cards mt-32">
      <h4 class="mb-3">
        每日限量优惠码名额
      </h4>
      <div class="card flex my-0 mx-auto justify-center items-center flex-col md:flex-row">
        <div class="card-1">
          <img src="@/assets/bias-fx2-coupon/ratio1.png">
          <span>每日 2 名</span>
        </div>
        <div class="card-2">
          <img src="@/assets/bias-fx2-coupon/ratio2.png">
          <span>每日 5 名</span>
        </div>
        <div class="card-3">
          <img src="@/assets/bias-fx2-coupon/ratio3.png">
          <span>每日 15 名</span>
        </div>
      </div>
      <div class="card flex my-0 mt-6 mx-auto justify-center items-center flex-col md:flex-row">
        <div class="card-full w-full my-4 mx-0">
          <h3 class="text-2xl font-normal my-3">
            还有众多其他折数的优惠码
          </h3>
          <h3 class="text-2xl font-normal my-3">
            马上试试手气！
          </h3>
        </div>
      </div>
    </section>
    <section class="step">
      <span v-if="!completed">
        <div
          v-if="!loggedIn"
          class="step-1"
        >
          <h3>
            注册/登录帐号，取得抢红包资格
          </h3>
          <button @click="login()">注册/登录</button>
        </div>
        <div
          v-else
          class="step-2"
        >
          <button
            v-if="timePassed"
            :disabled="running"
            @click="getCoupon()"
          >点击抢红包</button>
          <button
            v-else
            disabled
          >1/20 10AM 准时开放抢码</button>
        </div>
      </span>
      <div
        v-if="code"
        class="step-3"
      >
        <div class="coupon-msg relative flex justify-center items-center">
          <img src="@/assets/bias-fx2-coupon/group-23.png">
          <span class="absolute text-white text-xl">恭喜获得<br><span class="text-7xl font-bold">{{ ratio * 10 }}</span><br>折优惠码</span>
        </div>
        <h2>
          优惠码：{{ code }}
        </h2>
        <p>此优惠码亦已通过电子邮箱发放给您</p>
        <button @click="$router.push('/bias-fx2#buy')">
          立即使用优惠码
        </button>
      </div>
      <div
        v-if="couponFailed"
        class="step-4"
      >
        <div class="coupon-msg relative flex justify-center items-center mb-6">
          <img src="@/assets/bias-fx2-coupon/group-23.png">
          <span class="absolute text-white whitespace-pre">{{ errorMsg }}</span>
        </div>
        <button @click="$router.push('/bias-fx2#buy')">
          立即使用优惠码
        </button>
      </div>
    </section>
    <div class="divider relative overflow-hidden w-full h-10">
      <img
        class="transform-translate-50 left-50 top-50 absolute"
        src="@/assets/bias-fx2-coupon/group-7-up.svg"
      >
    </div>
    <section class="info">
      <div class="notes text-left">
        注意事项：
        <ul>
          <li>*每个帐号限抢码一次</li>
          <li>*优惠码使用期限至 2020 年 2 月 29 日 23:59 止</li>
        </ul>
      </div>
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import axios from 'axios'
import Banner from '@/components/banner'
import { mapState } from 'vuex'
import store from '@/store'
import urls from '@/urls'
import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'
export default {
  store,
  components: {
    Banner,
    FooterCommon,
    FooterWeixin
  },
  data () {
    return {
      code: null,
      ratio: null,
      couponFailed: false,
      completed: false,
      running: false,
      errorMsg: ''
    }
  },
  computed: {
    ...mapState('Auth', {
      loggedIn: 'loggedIn',
      tokenInfo: 'info'
    }),
    timePassed: function () {
      return new Date() > new Date('2020-01-20T02:00:00.000Z')
    }
  },
  mounted: function () {
    if (new Date() > new Date('2020-01-23T16:00:00.000Z')) {
      this.$router.push('/bias-fx2')
    }
    if (this.$route.query['login']) {
      window.scrollTo(0, document.getElementById('registeration').offsetTop)
    }
  },
  methods: {
    login () {
      const result = new URL(`${urls.USER_CENTER_URL}/store_auth`)
      result.searchParams.set('redirect_to', '/')
      result.searchParams.set(
        'redirect_host',
        `${window.location.toString()}?login=`
      )
      result.searchParams.set('back_to', '/')
      document.location = result
    },
    async getCoupon () {
      try {
        this.running = true
        const result = await axios({
          method: 'POST',
          headers: {
            Authorization: `JWT ${window.localStorage.getItem('PG_TOKEN')}`,
            'Content-Type': 'application/json'
          },
          url:
            'https://wgj5tuye0k.execute-api.us-east-1.amazonaws.com/latest/raffle-cn',
          validateStatus: function (status) {
            return status => 500
          }
        })

        if (result.status === 200) {
          this.code = result.data.code
          this.ratio = result.data.ratio
        }
        if (result.status === 400) {
          this.couponFailed = true
          switch (result.data.code) {
            case 'ALREADY_APPLIED':
              this.errorMsg = '感谢参与抢得红包\n请至您的电子邮箱查看优惠码'
              break
            case 'NOT_EVENT_TIME':
              this.errorMsg = '活动尚未开始或已经结束\n感谢您的参加'
              break
            case 'UNAUTHORIZED':
              this.errorMsg = '验证错误\n请稍后再试'
              break
            case 'SYSTEM_ERROR':
              this.errorMsg = '发生未知错误\n请稍后再试'
              break
            default:
              this.errorMsg = '发生未知错误\n请稍后再试'
              break
          }
        }
        this.completed = true
        this.running = false
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/base/breakpoint.scss";
* {
  color: #fdcb76;
}

.left-50 {
  left: 50%;
}

.top-50 {
  top: 50%;
}

.transform-translate-50 {
  transform: translate(-50%, -50%);
}

.text-7xl {
  font-size: 5rem;
}

.bias-fx2-coupon {
  background: url('../assets/bias-fx2-coupon/bg-1.jpg') repeat;
}

.hero {
  min-height: 90vh;
  h1 {
    font-size: 30px;
    @include breakpoint("medium") {
      font-size: 72px;
    }
    line-height: 1.5;
  }

  h2 {
    font-size: 20px;
    @include breakpoint("medium") {
      font-size: 36px;
    }
    margin: 0;
  }
  h3 {
    font-size: 24px;
  }

  .background-img {
    height: 600px;
    width: 830px;
    background: left top / auto no-repeat url(../assets/bias-fx2-coupon/group-27.svg), 95% 75% / 30% no-repeat url(../assets/bias-fx2-coupon/group-27.svg), center center / auto no-repeat url(../assets/bias-fx2-coupon/group-28.svg), 20% bottom / auto no-repeat url(../assets/bias-fx2-coupon/group-10-copy.svg), right 65% / 10% no-repeat url(../assets/bias-fx2-coupon/group-9-copy.svg);
  }
}
.time,
.cards,
.step,
.info {
  margin: 3rem auto;
  text-align: center;
  width: 90%;
  @include breakpoint("medium") {
    width: 740px;
  }
}
.cards {
}

.time {

}
.card {
  max-width: 815px;
  h3,
  h4 {
    margin: 0;
  }
  h3 span {
    font-size: 30px;
  }
  h4 {
    font-size: 41.6px;
    margin-left: 30px;
  }
  h4 span {
    font-size: 16.6px;
  }
  h3::before,
  h4::before {
    display: none;
  }
  &-full {
    h3 span {
      font-size: 28px;
      @media screen and (max-width: 1350px) {
        font-size: 25px;
      }
      font-weight: bold;
    }
    p {
      margin-top: 5px;
      font-size: 16px;
      font-weight: normal;
    }
  }
}
.step {
  h4 {
    margin-top: 40px;
  }
  &-3,
  &-4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
  }
  &-3 {
    h3,
    h2 {
      color: #fff;
      margin-top: 0;
      margin-bottom: 0;
    }
    p {
      color: #fff;
      font-size: 12px;
      margin-bottom: 3rem;
    }
    h2 {
      font-size: 24px;
      span {
        font-size: 24px;
        text-decoration: underline;
      }
    }
    hr {
      min-width: 35%;
      border: 1px solid #979797;
      margin-top: 35px;
      margin-bottom: 35px;
    }
    h3 {
      font-size: 20px;
      margin-bottom: 52px;
      span:nth-of-type(1) {
        font-size: 82px;
        font-weight: bold;
      }
      span:nth-of-type(2) {
        font-size: 42px;
      }
      span {
        margin-right: 0;
      }
    }
  }
  &-1,
  &-2 {
    h3 span {
      margin-right: 2rem;
      font-weight: 100;
    }
    h3 {
      margin-top: 55px;
      margin-bottom: 32px;
    }
  }
  button {
    width: 240px;
    height: 48px;
    border-radius: 4px;
    border: solid 1px rgba(255, 255, 255, 0.66);
    background-color: #ff3a00;
  }
}

.coupon-msg {
  span {
    color: #fff;
  }
}

hr {
  border: solid 1px #3ae0bd;
}
button:disabled {
  filter: grayscale(100%);
}

.page-bg {
  transform: translate(-50%, 0);
  width: 1440px;
  height: 2000px;
  background: left top / auto no-repeat url(../assets/bias-fx2-coupon/group-10-copy-2.svg), 15% 11% / auto no-repeat url(../assets/bias-fx2-coupon/group-9-copy.svg), 2% 15% / auto no-repeat url(../assets/bias-fx2-coupon/group-9-copy.svg), 96% top / auto no-repeat url(../assets/bias-fx2-coupon/group-10.svg), right 23% / auto no-repeat url(../assets/bias-fx2-coupon/group-9.svg), left 70% / auto no-repeat url(../assets/bias-fx2-coupon/group-10-copy-3.svg),;

  @media screen and (min-width: 1440px) {
      width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/bias-fx2-coupon.vue